<template>
  <!-- Consentement démarchage -->
  <input-radio
    label=""
    class="col-3"
    slug="consent"
    :model="consent"
    :options="[
      {'label': 'Oui', 'value': '1'},
      {'label': 'Non', 'value': '0'}
    ]"
    :v$="v$"
    @input="$emit('update:consent', $event.target.value)"
  />

  <!-- Téléphone -->
  <Transition>
    <input-text
      v-if="consent === '1'"
      class="col-6"
      label="Téléphone"
      slug="telephone"
      :model="telephone"
      :v$="v$"
      @input="$emit('update:telephone',$event.target.value)"
    />
  </Transition>
</template>

<script>

import InputText from "src/modules/shared/components/Form/InputText";
import InputRadio from "src/modules/shared/components/Form/InputRadio";
import {computed} from "vue";
import {required, requiredIf, serverError} from "@/modules/shared/validators/validators";
import useVuelidate from "@vuelidate/core";
/**
 * Demarchage Telephonique
 * Un composant pour remonter le consentement au démarchage
 * et le numéro de téléphone si il y a consentement
 */
export default {
  name: 'DemarchageTelephonique',
  components: {
    InputRadio,
    InputText,
  },
  props: {
    serverErrors: {
      type: Array,
      required: true
    },
    consent: {
      type: String,
      default: ''
    },
    telephone: {
      type: String,
      default: ''
    },
  },
  emits: [
    'update:consent',
    'update:telephone',
  ],
  setup (props) {
    const validations = computed(() => ({
      consent: {
        required,
        serverError: serverError(props, 'consent')
      },
      telephone: {
        requiredIf: requiredIf(props.consent === '1'),
        serverError: serverError(props, 'telephone')
      },
    }))

    const v$ = useVuelidate(validations, props)

    return { v$ }
  },
  watch: {
    serverErrors () {
      this.v$.$reset()
      this.v$.$touch()
    }
  },
}
</script>

<style scoped>
.v-enter-active,
.v-leave-active {
  transition: opacity .5s ease;
}
.v-enter-from,
.v-leave-to {
  opacity: 0;
}
</style>

